import React from 'react';
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DashboardIcon from '@material-ui/icons/Dashboard';
import {Link, Redirect} from "react-router-dom";

class AllyHeaderComponent extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            redirectToAllyLogin: false
        }
    }

    closeSession(){
        this.setState({redirectToAllyLogin: true})
        localStorage.clear();
    }

    redirectToAllyLogin = () => {
        if (this.state.redirectToAllyLogin) {
            return <Redirect push to='/aliados' />
        }
    }

    render(){
        return(
            <React.Fragment>
                {this.redirectToAllyLogin()}
                <Grid container spacing={0}>
                    <AppBar position="static">
                        <Toolbar>
                            <Link to="/alidos-panel" className='headerHomeIcon'>
                                <IconButton edge="start" color="inherit" aria-label="Menu">
                                    <DashboardIcon />
                                </IconButton>
                            </Link>
                            <Typography variant="h6" className='headerComponentTitle'>
                                SISTEMA DE INFORMACION FLOMECOL&reg; | ALIADOS
                            </Typography>
                            <Button onClick={this.closeSession.bind(this)} color="inherit">Cerrar Sesión</Button>
                        </Toolbar>
                    </AppBar>
                </Grid>
            </React.Fragment>
        )
    }
}

export default AllyHeaderComponent;